import { LastBackupBody, LastHomeBackupContainer } from './styles'
import { SectionLabel } from 'components/Typography'
import IntlFormattedDate from 'app/i18n/IntlFormattedDate'

interface LastHomeBackupProps {
  lastBackup: number | null
}

function LastHomeBackup({ lastBackup }: LastHomeBackupProps) {
  return (
    <LastHomeBackupContainer>
      <SectionLabel>Last Home Backup</SectionLabel>
      <LastBackupBody>
        <IntlFormattedDate
          date={lastBackup}
          defaultReturn="Requires SavantOS 10.1 or later & Savant Essentials"
          withTime
        />
      </LastBackupBody>
    </LastHomeBackupContainer>
  )
}

export default LastHomeBackup
